import React, { useContext, useEffect, useRef, useState } from 'react'
import Slider from "react-slick";
import { getImages } from '../Components/const';
import { VehicleContext } from '../Components/Context/VehicleContext';
import MyVehicleForm from '../Components/SellOrTrade/MyVehicleForm';
import UseScrollReveal from '../Components/Common/UseScrollReveal ';
import { Link } from 'react-router-dom';
import ModalLayout from '../Components/Common/ModalLayout';
import GetQuoteModal from '../Components/SellOrTrade/GetQuoteModal';
import SeoMeta from '../Components/Common/SeoMeta';

const reviewsList = [
    {
      name: "Keith Smith (Mayorofmycity)",
      date: '2 months ago',
      content:
        "I had an excellent experience working with Matt Yates at McLaren Orlando. His customer service is truly exceptional right from the start, I felt at ease making such a large purchase for the first time. Matt guided me seamlessly through the entire process, answering every question I had with patience and professionalism. His dedication and expertise made what could have been a stressful experience completely smooth and enjoyable. I highly recommend Matt to anyone looking to get into a McLaren; you’ll be in great hands! Now I'm riding in a new McLaren 😎 🙌🏾",
    },
    {
      name: "Christopher Darling",
      date: '2 months ago',
      content:
        "My sales person, Matt Yates did a fantastic job working with me via phone and text for over a week. Patiently answered my questions and shared info on multiple versions of the Artura to help me make the best decision for me. He met with me outside regular hours and it ended up a seamless deal.",
    },
    {
      name: "Andy Ramirez",
      date: 'a month ago',
      content:
        "Matt was the best to work with and everyone from the front office to the back was extremely helpful throughout the whole process. They were patient and understanding. This was my first McLaren and I’ll definitely come back for my 2nd.",
    },
  
    {
      name: "Mark Zaremskas",
      date: 'a month ago',
      content:
        "First class dealership!! I have had three McLarens now (all bought second hand)...And none of them purchased from this dealership. I was unlucky as at the time they did not have exactly what I wanted (as I was looking for something very specific). My point here...Is that I was treated as if I had purchased multiple cars from McLaren Orlando! I continue to take my cars there for servicing...I am always treated fairly and feel like I am a valued customer! And the best part is the team of experts (George, Ryder and techs) have always handed my car(s) back in the condition expected with no issues. The new dealership is amazing...A",
    },
    {
      name: "Shaun Spry",
      date: '2 weeks ago',
      content:
        "Just closed a deal with Matt Yates. Excellent experience from initial walk-in to drive-out, which in my case took longer than usual. I knew very little about the brand, so I had lots of annoying questions. Matt was endlessly patient and never pushed. Zero pressure is how car buying should be! I also spent quality time with Joe. He runs a dealership focused on his clients, is a great guy, and has lots of fun stories and valuable insight. Highly recommend McLaren of Orlando!",
    },
  
    {
      name: "Hayden Mitchell",
      date: 'Edited 6 months ago',
      content:
        "Yesterday I took delivery of my 600LT (11/26/24) and wanted to share my experience working with this dealer. Purchasing a vehicle out of state can be stressful but Matt was great and helped answer questions and concerns about the car. The 600LT has been an absolute blast and I want to thank Matt and the team over at Mclaren of Orlando for making it happen.",
    },
    {
      name: "Jon Larsen",
      date: '5 months ago',
      content:
        "I had an amazing experience at McLaren Orlando leasing my 25 Artura Spyder. The car is amazing and I’m looking forward to the next few years of ownership . From the beginning, Matt Yates was instrumental in helping me through the entire process from the initial test drive to receiving the car. He was extremely helpful in making my decision to get the car easy and also with any questions I had after. He also helped me to get the most for my trade in on my 600LT. Thanks again to Matt Yates and all of the staff at McLaren Orlando!",
    },
  ];

const SellOrTrade = () => {
    const { getVehicleData, numberFormatter, filteredVehicleData } = useContext(VehicleContext);
    var srpCarSlider = {
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        centerPadding: '120px',
        arrows: true,
        dots: false,
        infinite: filteredVehicleData && filteredVehicleData.filter((item) => item.inventory_manage.featured).length > 3,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    };

    const sliderRef = useRef(null);
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 2,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    const [selectedValue, setSelectedValue] = useState("");
    const [getQuoteModal, setGetQuoteModal] = useState(false);
    const closeGetQuoteModal = () => {
        setGetQuoteModal(false)
    }
    const [openDragDropModal, setopenDragDropModal] = useState(false);
    const [previewURL, setPreviewURL] = useState(null);
    console.log("openDragDropModal", openDragDropModal)
    console.log("previewURL", previewURL)
    const closeDragDropModal = () => {
        setopenDragDropModal(false)
    }
    const [files, setFiles] = useState([]);

    useEffect(() => {
        console.log("home page useEffect");
        getVehicleData();

    }, []);
    
    UseScrollReveal();
    return (
        <>
            <SeoMeta
                title="Sell or Trade Your Exotic Car - Mclaren Orlando LLC"
                description="Mclaren Orlando offer the best deals when selling your exotic car. How do we offer the best deals? We only buy the best exotic cars in the best condition"
                keywords=""
                ogTitle="Sell or Trade Your Exotic Car - Mclaren Orlando LLC"
                ogDescription="Mclaren Orlando offer the best deals when selling your exotic car. How do we offer the best deals? We only buy the best exotic cars in the best condition"
            />
            <section className='common-banner-wrap'>
                <img src={getImages('sell-or-trade-hero-bg.webp')} alt='sell or trade' />
                <div className='common-banner-pos pt-140'>
                    <div className='container'>
                        <div className='d-flex align-items-center'>
                            <div className='w-100'>
                                <h4 className='xs-title text-uppercase font-1-1em fw-300 text-lgray reveal wow fadeIn'>McLaren Orlando</h4>
                                <h1 className='lg-title text-uppercase mt-2 reveal wow fadeIn'>Sell or Trade your Vehicle</h1>
                                <div className='mt-4 reveal wow fadeIn'>
                                    <a href='tel:4079880111' className='theme-btn text-uppercase d-inline-block'>407-988-0111</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='hassle-process-wrap'>
                <div className='container'>
                    <div className='hassle-process-box d-md-flex reveal wow fadeIn'>
                        <div className='hpb-left w-50'>
                            <div className='hpb-xs-title text-uppercase text-orange mb-2 reveal wow fadeInUp'>Call or text</div>
                            <div className='text-center'>
                                <a href='tel:4079880111' className='lg-title call-text-title text-white fw-700 reveal wow fadeInUp'>407-988-0111</a>
                            </div>
                            <h2 className='md-title font-1-9em text-center fw-300 text-uppercase mt-md-5 mt-4 mb-md-4 mb-3 reveal wow fadeInUp'>How Our Process Works</h2>
                            <div className='hpb-process-list'>
                                <div className='d-flex align-items-center reveal wow fadeInUp'>
                                    <div className='hpb-circle me-3'>1</div>
                                    <div className='xs-title font-1-1em fw-300 text-uppercase'>Send in your vehicle information</div>
                                </div>
                                <div className='d-flex align-items-center reveal wow fadeInUp'>
                                    <div className='hpb-circle me-3'>2</div>
                                    <div className='xs-title font-1-1em fw-300 text-uppercase'>Quickly receive an estimate</div>
                                </div>
                                <div className='d-flex align-items-center reveal wow fadeInUp'>
                                    <div className='hpb-circle me-3'>3</div>
                                    <div className='xs-title font-1-1em fw-300 text-uppercase'>Finalize with our friendly agents</div>
                                </div>
                            </div>
                        </div>
                        <div className='hpb-right w-50'>
                            <h2 className='lg-title text-uppercase font-3em fw-700 mb-md-5 mb-4 text-center reveal wow fadeInUp'>NO HASSLE <br />PROCESS</h2>
                            <MyVehicleForm
                                setSelectedValue={setSelectedValue}
                                getQuoteModal={getQuoteModal}
                                setGetQuoteModal={setGetQuoteModal}
                            />
                            <h4 className='sm-title text-center font-1-3em mt-90 fw-500 text-white reveal wow fadeInUp'>Simple, Fast & Free</h4>
                            <div className='text-center pt-3 reveal wow fadeInUp'>
                                <span className='px-5 d-inline-block hpb-border-t pt-3'>
                                    <img src={getImages('tg-logo-bw.png')} />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='deals-wrap'>
                <h3 className='hpb-xs-title text-uppercase mb-2 reveal wow fadeInUp'>TRADE UP FOR THE</h3>
                <h2 className='lg-title text-center fw-700 mb-5 reveal wow fadeInUp'>HOTTEST DEALS</h2>
                <div className='deals-block reveal wow fadeIn'>
                    {filteredVehicleData && (
                        <Slider className='deals-slider' {...srpCarSlider}>
                            {filteredVehicleData.filter((item) => item.inventory_manage.featured).map((item, index) => (
                                <div key={index} className='deal-col'>
                                    <div className='inner'>
                                        <article className="cs-card cs-card--2 fv-box">
                                            <div className="cs-card__img fv-top"
                                                style={{
                                                    backgroundImage: `url(${item.images[0]})`,
                                                }}
                                            ></div>
                                            <Link to={`/vehicle-details/${item.vdp_url ?? `used-${item.vin}`}`} target='_blank' className="cs-card_link">
                                                <div className="cs-card__img--hover fv-top"
                                                    style={{
                                                        backgroundImage: `url(${item.images[0]})`,
                                                    }}></div>
                                            </Link>
                                            <div className="fv-bottom">
                                                <div className="sm-title text-white fw-300 deal-main-title text-start">{item.year} {item.make} {item.model}</div>
                                                <div className="d-flex align-items-end justify-content-between mt-1">
                                                    <div className="fv-price fw-500">{numberFormatter(item.price, true)}</div>
                                                    <div className="fv-mileage opacity-0-7 font-1em">{numberFormatter(item.mileage)}</div>
                                                </div>
                                                <div className='mt-3'>
                                                    <Link to={`/vehicle-details/${item.vdp_url ?? `used-${item.vin}`}`} target='_blank' className='vehicle-dtl-btn text-center w-100 d-inline-block text-uppercase'>Vehicle Details</Link>
                                                </div>
                                            </div>
                                        </article>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    )}
                </div>
            </section>
            <section className='sell-or-trade-wrap'>
                <div className='container'>
                    <div className='d-md-flex justify-content-between sot-flex'>
                        <div className='reveal wow fadeInUp'>
                            <div className='mb-3'>
                                <img src={getImages('tg-logo-bw.svg')} />
                            </div>
                            <h2 className='md-title text-start font-1-7em fw-700 text-uppercase'>Sell or Trade your Vehicle</h2>
                        </div>
                        <div className='sot-right reveal wow fadeInUp'>
                            <MyVehicleForm
                                setSelectedValue={setSelectedValue}
                                getQuoteModal={getQuoteModal}
                                setGetQuoteModal={setGetQuoteModal}
                                sotForm={true}
                            />
                        </div>
                    </div>
                </div>
            </section>
            <section className='reviews-wrap'>
                <div className='container'>
                    <h3 className='hpb-xs-title text-uppercase mb-2 reveal wow fadeInUp'>Recent</h3>
                    <h2 className='lg-title text-center fw-700 text-uppercase mb-md-5 mb-4 reveal wow fadeInUp'>Google Reviews</h2>
                    <div className=' reveal wow fadeIn'>

                        <Slider ref={sliderRef} {...settings} className='review-slider'>
                            {reviewsList.map((review, index) => (
                                <div className="review-item" key={index}>
                                    <div className="review-box">
                                        <div className="review-mnh">
                                            <p className="clamp-4">
                                                {review.content}
                                            </p>
                                        </div>
                                        <div className="d-flex align-items-end justify-content-between mt-1">
                                            <div>
                                                <div className="mb-md-3 mb-2 d-flex align-items-center">
                                                    {[...Array(5)].map((_, i) => (
                                                        <img key={i} className="me-1" src={getImages("star.svg")} alt="star" />
                                                    ))}
                                                </div>
                                                <div className="reviewer-name">{review.name}</div>
                                            </div>
                                            <div>
                                                <div className="quote-icon mb-2">
                                                    <img src={getImages("quote-shape.png")} alt="quote" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}

                        </Slider>
                    </div>
                </div>
            </section>
            <section className='trading-wrap'>
                <div className='container'>
                    <h2 className='lg-title text-center fw-300 fw-500 text-uppercase mb-md-4 mb-3 reveal wow fadeInUp'>Tips on Trading or Selling Your Vehicle</h2>
                    <div className='reveal wow fadeInUp'>
                        <p>To find the right buyer for your used car, starting with a professional vehicle appraisal is a smart move. While several exotic car buyers operate in the market, partnering with a reputable company is key. Established dealerships in the United States adhere to specific standards and regulations, offering a level of assurance that individual buyers may not provide.</p>

                        <p>We specialize in purchasing exotic vehicles, drawing upon our team's extensive experience in the high-end automotive market. When selecting a used car buyer, prioritize expertise and a proven track record. Following your car appraisal, you can efficiently move forward to receive a cash offer or explore trade-in options for your vehicle.</p>
                    </div>
                </div>
            </section>
            <ModalLayout open={getQuoteModal} close={closeGetQuoteModal} darkThemeCls='true' modalWidth={750}>
                <GetQuoteModal 
                    selectedValue={selectedValue}
                    close={closeGetQuoteModal}
                    setopenDragDropModal={setopenDragDropModal}
                    setPreviewURL={setPreviewURL}
                    files={files}
                    setFiles={setFiles}
                />
            </ModalLayout>
        </>
    )
}

export default SellOrTrade